<template>
  <div id="main">
    <Title>Fretboard Editor</Title>
    <p>
      Create your own fretboard diagram
    </p>
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <v-slider
            v-model="item.start_fret"
            label="Start Fret"
            min="0"
            max="12"
            step="1"
            ticks="always"
            thumb-label="always"
          ></v-slider>
        </v-col>
        <v-col cols="12" md="6">
          <v-slider
            v-model="item.num_frets"
            label="Width (frets)"
            min="4"
            max="12"
            step="1"
            ticks="always"
            thumb-label="always"
          ></v-slider>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-card outlined>
          <v-card-text>
            <Fretboard
              :notes="item.spec"
              :frets="item.num_frets"
              :startFret="item.start_fret"
              :noteClicked="noteClicked"
            />
          </v-card-text>
          <v-card-actions>
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    :items="choices.fretboard_class"
                    v-model="item.fretboard_class"
                    label="Class"
                  ></v-select>
                </v-col>
                <v-col cols="4" md="3">
                  <v-select
                    :items="choices.root"
                    v-model="item.root"
                    label="Root"
                  ></v-select>
                </v-col>
                <v-col cols="8" md="9">
                  <v-text-field label="Name" v-model="item.name"></v-text-field>
                </v-col>
                <v-col cols="6" md="4">
                  <v-btn
                    text
                    color="blue-grey darken-2"
                    :disabled="!item.name || item.spec == ''"
                    @click="save"
                  >
                    <v-icon>mdi-content-save</v-icon>
                    {{ item.id === null ? "Create" : "Update" }}
                  </v-btn>
                  <v-btn
                    text
                    v-if="item.id !== null"
                    color="blue-grey"
                    :disabled="!item.name || item.spec == ''"
                    @click="saveNew"
                  >
                    <v-icon>mdi-content-save</v-icon> Save as new
                  </v-btn>
                  <v-btn
                    text
                    color="blue-grey"
                    v-if="item.fretboard_class == 'C'"
                    :disabled="playing"
                    @click="playNotes"
                  >
                    <v-icon>mdi-play</v-icon> Play
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import * as Tone from "tone";

import Fretboard from "@/components/Fretboard.vue";

const synth = new Tone.PolySynth(Tone.Synth).toDestination();
const DURATION = 0.4;

export default {
  name: "FretboardEditor",
  components: {
    Fretboard
  },
  data: () => ({
    item: {
      id: null,
      name: "",
      spec: "",
      num_frets: 5,
      start_fret: 0,
      root: "C",
      fretboard_class: "C"
    },
    specList: [],
    playing: false
  }),
  created() {
    this.loadChoices();
  },
  computed: {
    ...mapState("fretboards", ["choices"])
  },
  methods: {
    ...mapActions("fretboards", ["saveFretboard", "loadChoices"]),
    noteClicked({ string, note }) {
      const spec = `${string}:${note}`;
      if (this.specList.indexOf(spec) !== -1) {
        this.specList.splice(this.specList.indexOf(spec), 1);
      } else {
        this.specList.push(spec);
        this.playNote(note);
      }
      // this.specList.sort();
      this.item.spec = this.specList.join(" ");
    },
    async save() {
      const saved = await this.saveFretboard(this.item);
      this.item.id = saved.id;
    },
    async saveNew() {
      this.item.id = null;
      await this.save();
    },
    playNote(note, when = 0) {
      if (when === 0) {
        when = Tone.now();
      }
      synth.triggerAttackRelease(note.toUpperCase(), "8n", when);
    },
    playNotes() {
      this.playing = true;
      const now = Tone.now();
      let i = now;
      for (let item of this.specList) {
        let [, note] = item.split(":");
        this.playNote(note, i);

        i += this.item.fretboard_class == "C" ? 0 : DURATION;
      }
      // TODO: use a `Loop` and wait until completion.
      this.playing = false;
    }
  }
};
</script>
<style scoped>
#main {
  max-width: 600px;
}
</style>
